<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">

     <span class="mr-lg-4">
     <i class="fa fa-user" style="font-size: 22px; color: #24A0ED;" />
    </span>

    </template>
    <template slot="dropdown" >
      <b-dropdown-header tag="div" class="text-center">
        <strong>{{ this.adminuser }}</strong>
      </b-dropdown-header>
      
      <!--
      <b-dropdown-item><i class="fa fa-bell-o" /> Updates
        <b-badge variant="info">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-envelope-o" /> Messages
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-tasks" /> Tasks
        <b-badge variant="danger">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-comments" /> Comments
        <b-badge variant="warning">{{ itemsCount }}</b-badge>
      </b-dropdown-item> 
      -->

      
     <!-- <b-dropdown-item   @click="editinfoModal"  data-toggle="tooltip" title="Change Password!"><i class="fa fa-key" /> Change Password</b-dropdown-item> -->
      
      <!-- <b-dropdown-divider /> -->
      <!-- <b-dropdown-item><i class="fa fa-shield" /> Lock Account</b-dropdown-item> -->
      <b-dropdown-item @click="profile" data-toggle="Profile" title="Profile"><i class="fa fa-user"></i> Profile </b-dropdown-item>
      <b-dropdown-item  @click="logout"  data-toggle="tooltip" title="Logout"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
      

      <!--  <b-dropdown-item   data-toggle="tooltip" title="Logout!" @click="logout"><router-link :to="'/cams_login'">Logout</router-link></b-dropdown-item> -->
    </template>
           <!-- Code for Edit  -->
<!--       <b-modal title="Update Password" v-model="changepassword" @ok="changepassword = false">
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Change Password</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">
                <b-form-group
                  label="Change Password"
                  :label-cols="3" >
                  <b-form-input type="text" name="password"  v-model="customer.password" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-5.password') }"placeholder="Enter New Password">
                  </b-form-input>
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('password')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.password')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.password') }}
                      </code>
                      </b-input-group>
                                 
                </b-form-group>

                
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                  <b-button  size="sm" variant="danger" @click="editcancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
          </template>
      </b-modal>  -->
            <!-- Code For Edit Ends -->
  </AppHeaderDropdown>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
const axios = require('axios')


export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
      itemsCount: 42,
      email: '',
      adminuser:'',
      access_token:'',
      changepassword: false,
      get codUser() {
        return localStorage.getItem('Coduser') || '';
      }
    }

  },
  created() {
        if (!localStorage.userData) {
          localStorage.redirectUrl = window.location.href;
          window.location.href = window.location.origin + '/cams_login';
        } 
    // console.log('Coduser: '+localStorage.getItem('Coduser'));
     var userData = localStorage.getItem('userData')
     var userInfo = JSON.parse(userData)
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
   // let setHeader=JSON.parse(localStorage.getItem('userData'));
   // this.access_token=userInfo[0]['token']
                  // axios.defaults.headers.common['x-access-token'] = this.access_token;
   // console.log("UUUxxxxxxxxxxxxxxxxxxxxxxxxxxxxxUUUUUUU",setHeader)
   // Vue.http.headers.common['x-access-token']  = setHeader.userInfo[0].['token'];
    // this.codUser = localStorage.getItem('Coduser')
   //  console.log('coddd',this.codUser);
    this.getuserdetails()
  },
  methods: {
    editinfoModal: function(value) {
      this.customer.password = value.password,
      this.customer.user_id = value.user_id
      this.changepassword = !this.changepassword;
    },
    getuserdetails: function() {
      var userData = localStorage.getItem('userData')
      if (userData) {
        var userInfo = JSON.parse(userData)
        this.email = userInfo[0].email_id
        this.adminuser=userInfo[0].full_name;
        if (this.email !== '') {} else {
          //this.$router.push('login')
        }
      } else {
        // this.$router.push('login');
        // $location.path( "/cams_login" );
        // this.$router.push('/cams_login')
      }
    },
    logout: function () {
      var userData = localStorage.getItem('userData')
      if (userData) {
        var userInfo = JSON.parse(userData)
        if (userInfo[0].camsToken === '' || userInfo[0].camsToken == null) {
          const data = {
            user_id: userInfo[0].user_id
          }
          axios.post(`${CONSTANTS.API_URL}/signout`, data)
            .then((response => {
              if (response.data.returnmsg === "Successful") {
                localStorage.setItem('userData', '')
                localStorage.setItem('activeTime', '')
                localStorage.setItem('Coduser', '')
                localStorage.setItem('filters', '')
                localStorage.setItem('filters', null)
                localStorage.setItem('brand_id', '')
                localStorage.setItem('selectedBrandId', '')
                localStorage.filters = '',
                this.$router.push('/cams_login');
              }
              else {
              localStorage.setItem('userData', '')
              localStorage.setItem('activeTime', '')
              localStorage.setItem('Coduser', '')
              localStorage.setItem('filters', '')
              localStorage.filters = '',
              this.$router.push('/cams_login');
                
                // this.$fire({
                //   text: `${response.data.returnvalue}`,
                //   type: "error",
                //   timer: 30000,
                // });
              }
            })).catch((err) => {
              localStorage.setItem('userData', '')
              localStorage.setItem('activeTime', '')
              localStorage.setItem('Coduser', '')
              localStorage.setItem('filters', '')
              localStorage.filters = '',
              this.$router.push('/cams_login');
              console.log('error while logging out',err)
              // this.$fire({
              //   text: err,
              //   type: "error",
              //   timer: 30000,
              // });
            })
        } else {
          let obj = {
            camsToken: userInfo[0].camsToken,
            emailaddress: userInfo[0].email_id,
            systemkey: "14524M1351240531",
            token: userInfo[0].token
            
          }
          axios.post(`${CONSTANTS.API_URL}/camsLogOut`, obj)
            .then(response => {
              if (response.data.returnmsg == "Successful") {
                localStorage.setItem('userData', '')
                localStorage.setItem('activeTime', '')
                localStorage.setItem('Coduser', '')
                localStorage.setItem('filters', '')
                localStorage.filters = '',
                this.$router.push('/cams_login');
              } else {
               localStorage.setItem('userData', '')
               localStorage.setItem('activeTime', '')
               localStorage.setItem('Coduser', '')
               localStorage.setItem('filters', '')
               localStorage.filters = '',
               this.$router.push('/cams_login');
              }
            }).catch((err) => {
                localStorage.setItem('userData', '')
                localStorage.setItem('activeTime', '')
                localStorage.setItem('Coduser', '')
                localStorage.setItem('filters', '')
                localStorage.filters = '',
                this.$router.push('/cams_login');
              // this.$fire({
              //   text: err,
              //   type: "error",
              //   timer: 30000,
              // });
              console.log("error while logging out",err)
            })
        }
      }
    },

    profile() {
      // updateProfile
      this.$router.push("/updateProfile").catch(() => { });
    }
  }
}
</script>
